import styled, { keyframes } from 'styled-components';

// Deliberately off-palette celebratory colors — the burst always renders on the card's black surface.
export const CONFETTI_COLORS = [
  '#7F7AFF',
  '#FFC943',
  '#FF6B8B',
  '#4ED4A9',
  '#3FA9F5',
];

const burst = keyframes`
  0% {
    transform: translate(-50%, -50%) rotate(0deg) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(calc(-50% + var(--tx)), calc(-50% + var(--ty)))
      rotate(var(--rot)) scale(0.3);
    opacity: 0;
  }
`;

export const Container = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;

  width: 0;
  height: 0;

  pointer-events: none;
  z-index: 2;
`;

export const Particle = styled.span<{
  $tx: number;
  $ty: number;
  $rot: number;
  $color: string;
}>`
  position: absolute;
  top: 0;
  left: 0;

  width: 6px;
  height: 3px;
  border-radius: 1px;
  background: ${({ $color }) => $color};

  --tx: ${({ $tx }) => `${$tx}px`};
  --ty: ${({ $ty }) => `${$ty}px`};
  --rot: ${({ $rot }) => `${$rot}deg`};

  transform: translate(-50%, -50%);
  animation: ${burst} 700ms ease-out forwards;
`;
